// extracted by mini-css-extract-plugin
module.exports = {"btn-color":"LoginInit_btn-color__3B0-h","profileImagePic":"LoginInit_profileImagePic__1V7_8","cardbody-color":"LoginInit_cardbody-color__t9_sm","link":"LoginInit_link__1UTjv"};